var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoEdShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 100,
    viewBox: "0 0 177 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_400)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.746 80.408C10.153 73.807 0 59.12 0 42.063C0 18.833 18.832 0 42.063 0C65.294 0 84.127 18.832 84.127 42.063C84.127 59.015 74.099 73.625 59.652 80.284C51.744 90.574 42.152 99.28 42.152 99.28C42.152 99.28 32.635 90.644 24.746 80.408ZM42.063 77.208C61.473 77.208 77.208 61.473 77.208 42.063C77.208 22.653 61.473 6.918 42.063 6.918C22.653 6.918 6.918 22.653 6.918 42.063C6.918 61.473 22.653 77.208 42.063 77.208Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.1617 44.558C73.6363 52.0013 70.5231 59.0262 65.3617 64.415C63.5887 61.816 60.9677 59.36 57.7257 57.151C53.5897 54.34 48.4007 51.909 42.5117 50.101C45.1567 48.975 47.8658 48.0056 50.6247 47.198C57.2487 45.251 63.7067 44.332 69.4447 44.332C71.0847 44.332 72.6557 44.408 74.1617 44.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8329 28.559C53.6269 25.223 61.3499 23.466 67.9729 23.189C72.0628 28.706 74.2657 35.3943 74.2549 42.262C74.2549 42.369 74.2449 42.477 74.2449 42.59C72.65 42.4398 71.0489 42.3644 69.4469 42.364C64.9769 42.364 60.1209 42.904 55.1069 44.014C51.0019 39.712 44.9279 35.761 37.5859 32.726C40.2443 31.1644 42.9988 29.7726 45.8329 28.559Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9355 49.5419C13.9145 49.0219 17.1825 48.7389 20.6495 48.7499C24.6814 48.7593 28.7053 49.1082 32.6785 49.7929C42.2655 51.4159 50.6715 54.7249 56.6205 58.7729C59.8685 60.9779 62.3455 63.3879 63.9325 65.8229C58.2135 71.1049 50.5725 74.3369 42.1735 74.3369C26.9645 74.3369 14.2325 63.7469 10.9355 49.5419Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6498 46.782C17.0848 46.792 13.6828 47.076 10.5498 47.62C10.2457 45.8482 10.0925 44.0538 10.0918 42.256C10.0918 37.576 11.1048 33.136 12.9028 29.123C17.5318 29.333 22.5148 30.084 27.6178 31.435C38.3608 34.276 47.3628 39.184 52.8658 44.537C51.9348 44.774 51.0048 45.02 50.0708 45.297C46.4438 46.361 43.0048 47.769 39.8408 49.227C37.6008 48.627 35.4068 48.251 33.0078 47.847C28.7428 47.127 24.5878 46.782 20.6498 46.782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1268 29.535C23.2048 28.23 18.3797 27.468 13.8438 27.196C19.2378 17.069 29.8997 10.175 42.1737 10.175C51.8737 10.175 60.5617 14.485 66.4507 21.293C59.8887 21.765 52.5008 23.559 45.0557 26.745C41.707 28.1719 38.4667 29.8409 35.3608 31.739C33.0287 30.86 30.6708 30.2071 28.1268 29.535Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.269 75.9768C129.837 75.9768 130.509 75.3795 130.733 73.8115L131.48 67.9875C131.704 66.4195 131.032 65.8968 129.464 65.8968H113.336L114.755 54.6968H128.941C130.509 54.6968 131.181 54.0995 131.405 52.5315L132.077 47.0808C132.301 45.5128 131.704 44.9902 130.136 44.9902H115.949L117.144 35.2835H132.525C134.093 35.2835 134.765 34.6862 134.989 33.1182L135.736 27.2942C135.96 25.7262 135.288 25.2035 133.72 25.2035H108.184C106.616 25.2035 105.944 25.8755 105.72 27.4435L100.045 73.7368C99.8214 75.3048 100.419 75.9768 101.987 75.9768H128.269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.172 72.4675V73.7368C159.172 75.3048 159.47 75.9768 161.038 75.9768H168.206C169.774 75.9768 170.446 75.3048 170.67 73.7368L176.494 26.0248C176.644 24.6061 176.27 23.7848 174.628 23.7848H166.937C165.369 23.7848 164.772 24.4568 164.548 26.0248L162.606 41.9288C160.665 40.2861 156.708 38.0461 151.556 38.0461C143.641 38.0461 140.356 42.4515 139.46 49.5448L137.518 65.0755C137.444 65.6728 137.369 66.4941 137.369 67.1661C137.369 72.9901 140.953 76.5741 147.524 76.5741C153.721 76.5741 156.857 74.1101 159.172 72.4675ZM151.182 51.4115C151.406 49.9181 151.705 48.2755 154.468 48.2755C157.305 48.2755 160.068 50.2168 161.486 51.3368L159.993 63.2835C158.276 64.4035 155.065 66.3448 152.228 66.3448C150.062 66.3448 149.614 65.3741 149.614 64.2541C149.614 63.8808 149.689 63.2835 149.764 62.6861L151.182 51.4115Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 177,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEdShort);
export default __webpack_public_path__ + "static/media/logo-ed-short.4fb7174e3865d5e5b5feea1e241c03f7.svg";
export { ForwardRef as ReactComponent };